import angular from 'angular';
import FooterBarComponent from './footer-bar-component';

export default angular.module('footer-bar', []).component('footerBar', new FooterBarComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/footer-bar/footer-bar-module.js